module.exports = __webpack_public_path__ + "media/images/web/header_home-2693ff8ae2a78ff0926b5e179dfe90fb.jpg";